export default __webpack_public_path__ + "static/media/tree-left.1172c775.png";